import { Order } from '@/types/order';
import { AppStore } from '..';
import api, { AbortedRequestError } from '../../api';

export default function FetchSessionOrders(store: AppStore) {
  store.dispatch({
    type: 'FETCH_SESSION_ORDERS_START',
  });

  return api
    .REST('GET', 'orders', store, {
      requireSessionUser: true,
    })
    .then((response) => {
      const orders: Array<Order> = response;
      const fetchedNumbers = orders.map((order) => order.Number);
      const ordersByNumber: {
        [orderNumber: Order['Number']]: Order;
      } = {};

      orders.forEach((order) => {
        ordersByNumber[order.Number] = order;
      });

      store.dispatch({
        type: 'FETCH_SESSION_ORDERS_SUCCESS',
        fetchedNumbers,
        ordersByNumber,
      });
    })
    .catch((error) => {
      if (error instanceof AbortedRequestError) {
        store.dispatch({
          type: 'FETCH_SESSION_ORDERS_ABORT',
        });
        return;
      }
      store.dispatch({
        type: 'FETCH_SESSION_ORDERS_FAIL',
        message: error.message || 'Unable to load orders',
      });
    });
}
